import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';

import {
	AllowedRulesInExplainType,
	ConfigurationModelSourceType,
	SessionFactory
} from '@viamedici-spc/configurator-ts';
import * as config from '../spcConfig';
import {getWizardAttributeRelations} from '../wizardAttributeRelations';

let updateConf = null;
let storeConf = null;

export const startSpcSession = createAsyncThunk(
	'spc/startSpcSession',
	async (options, {getState, dispatch}) => {
		const state = getState();

		const deploymentName = options?.deploymentName;
		const instance = options?.instance ?? 'default';

		const token = config.hcaEngineAccessTokenSelux;
		const channel = state.status.channel;
		const wars = getWizardAttributeRelations(deploymentName);
		// console.log('startSpcSession', instance, deploymentName, token, channel, wars);
		try {
			const spcSession = await SessionFactory.createSession({
				apiBaseUrl: state.status.engine2Url,
				sessionInitialisationOptions: {
					accessToken: token
				},
				configurationModelSource: {
					type: ConfigurationModelSourceType.Channel,
					deploymentName: deploymentName, //config.configurationModelPackage.deploymentName,
					channel: channel
				},
				allowedInExplain: {
					rules: {type: AllowedRulesInExplainType.all}
				},
				usageRuleParameters: {},
				wizardAttributeRelations: wars
			});
			await spcSession.addConfigurationChangedListener(
				(configuration, changes) => {
					dispatch(updateConf({
						instance: instance,
						deploymentName: deploymentName,
						configuration: configuration,
						changes: changes,
					}));
					spcSession.clearConfigurationChanges();
				});

			await spcSession.addStoredConfigurationChangedListener(
				(configuration) => {
					dispatch(storeConf({
						instance: instance,
						deploymentName: deploymentName,
						configuration: configuration,
					}));
				});
			return spcSession;
		} catch (error) {
			console.error('spcSession error', error);
			throw error;
		}
	}
);

const spcInitialState = {
	status: 'idle',
	sessions: {},
	spcs: {},
	error: {},
};
export const spcSlice = createSlice({
	name: 'spc',
	initialState: spcInitialState,
	reducers: {
		updateConfiguration: (state, action) => {
			// console.log('spc updateConfiguration', action.payload.instance, action.payload);
			const instance = '' + action.payload.instance;
			state.spcs[instance] = action.payload;
		},
		spcStoreConfiguration: (state, action) => {
			// console.log('spc storeConfiguration', action.payload.instance, action.payload);
			//const instance = '' + action.payload.instance;
			//state.spcs[instance] = action.payload;
		},
		closeSpcSession: (state, action) => {
			console.log('closeSpcSession', action.payload.instance, state.sessions, state.spcs);

			const instance = '' + action.payload.instance;
			const spcSession = state.sessions[instance];
			spcSession.close();

			// delete instance from state.spcs array
			delete state.sessions[instance];
			delete state.spcs[instance];
			console.log('deleted', instance, state.sessions, state.spcs);

		}
	},
	extraReducers: (builder) => {
		builder.addCase(startSpcSession.fulfilled, (state, action) => {
			const deploymentName = action.payload.getSessionContext().configurationModelSource.deploymentName;
			const instance = action.meta.arg.instance;
			console.log('startSpcSession.fulfilled', instance, deploymentName);
			state.sessions[instance] = action.payload;
			state.status = 'idle';
			state.error = {};
		});
		builder.addCase(startSpcSession.pending, (state, action) => {
			// console.log('startSpcSession.pending', state, action);
			state.status = 'loading';
			state.error = {};
		});
		builder.addCase(startSpcSession.rejected, (state, action) => {
			// console.log('startSpcSession.rejected', state, action);
			state.status = 'idle';
			state.error = action.payload;
		});
	}
});

export const {updateConfiguration, spcStoreConfiguration, closeSpcSession} = spcSlice.actions;

updateConf = updateConfiguration;
storeConf = spcStoreConfiguration;

export default spcSlice.reducer;
